<template>
  <div>
    <WindowsMoveSubscriptionComponent
      v-if="modalType === 'windowsTransfer'"
      :device="device"
      :show-dialog="showDialog"
      @cancel="close"
      @save="save"
    ></WindowsMoveSubscriptionComponent>
    <CrossPlatformTrialMoveSubscriptionComponent
      v-else-if="(modalType === 'windowsToMacTransfer' || modalType === 'macToWindowsTransfer') && isTrial"
      :device="device"
      :show-dialog="showDialog"
      @cancel="close"
    ></CrossPlatformTrialMoveSubscriptionComponent>
    <MacToWindowsMoveSubscriptionComponent
      v-else-if="(modalType === 'windowsToMacTransfer' || modalType === 'macToWindowsTransfer') && !isTrial"
      :device="device"
      :show-dialog="showDialog"
      @cancel="close"
    ></MacToWindowsMoveSubscriptionComponent>
    <MacToMacMoveSubscriptionComponent
      v-else-if="modalType === 'macTransfer'"
      :device="device"
      :show-dialog="showDialog"
      @cancel="close"
      @save="save"
    ></MacToMacMoveSubscriptionComponent>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from "vue";
import { IDevice } from "@/common/api/unifiedPortal/interfaces";
import { getOsFamily, isWindows } from "@/common/browserDetect";

import MacToMacMoveSubscriptionComponent from "@/components/Backup/MacToMacMoveSubscription.vue";
import MacToWindowsMoveSubscriptionComponent from "@/components/Backup/MacToWindowsMoveSubscription.vue";
import WindowsMoveSubscriptionComponent from "@/components/Backup/WindowsMoveSubscription.vue";
import CrossPlatformTrialMoveSubscriptionComponent from "@/components/Backup/CrossPlatformTrialMoveSubscription.vue";
import { logEvent } from "@/common/logger";

const componentName = "MoveMySubscriptionComponent";

export default defineComponent({
  name: componentName,
  components: {
    MacToMacMoveSubscriptionComponent,
    MacToWindowsMoveSubscriptionComponent,
    WindowsMoveSubscriptionComponent,
    CrossPlatformTrialMoveSubscriptionComponent,
  },
  props: {
    device: {
      type: Object as PropType<IDevice>,
      required: true,
    },
    showDialog: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["save-modal", "close-modal"],

  setup(props, context) {
    logEvent("created", componentName, props.device);

    const modalType = ref<string>("");
    const oldComputerOs = ref<string>("");
    const newComputerOs = ref<string>("");
    const isTrial = ref<boolean>(false);

    showModalContent();

    function save(installType: string) {
      context.emit("save-modal", installType);
    }

    function close() {
      context.emit("close-modal");
    }

    function showModalContent() {
      oldComputerOs.value = props.device.platform.toLowerCase();
      newComputerOs.value = getOsFamily().toLowerCase();
      isTrial.value = props.device.isTrial;
      modalType.value =
        oldComputerOs.value.includes(newComputerOs.value) || newComputerOs.value.includes(oldComputerOs.value)
          ? isWindows()
            ? "windowsTransfer"
            : "macTransfer"
          : isWindows()
          ? "macToWindowsTransfer"
          : "windowsToMacTransfer";
    }

    //Expose to template
    return {
      modalType,
      oldComputerOs,
      newComputerOs,
      isTrial,
      save,
      close,
    };
  },
});
</script>

<style scoped lang="css">
@import "@/styles/variables.css";
</style>
